<script setup>
import { Expo, TimelineMax } from 'gsap'
import { useRouter } from 'vue-router'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import B2CHeaderBG from 'components/home/B2CHeaderBG'
import B2CHeaderChart from 'components/home/B2CHeaderChart'
import B2CSearchBox from 'components/home/B2CSearchBox'
import { inject, onMounted } from 'vue'

const router = useRouter()
const { isProduction, isLoggedIn, isBrowser } = useGlobalStore()
const { screen } = inject('Shared')
onMounted(() => {
  setTimeout(() => {
    new TimelineMax({ repeat: 5, delay: 0, repeatDelay: 1 })
      .fromTo('.b2c-header-polygon',
        { opacity: 0 },
        { duration: 6, opacity: 1 },
        1)
      .fromTo('#polygon1',
        { attr: { points: '193.3,149.1 193.3,150.1 97.2,215.7 97.2,270.3 135.6,243.4 135.6,189.5' } },
        { attr: { points: '193.3,149.1 193.3,68.3 97.2,135.7 97.2,270.3 135.6,243.4 135.6,189.5' }, duration: 3.6 },
        1.5)
      .fromTo('#polygon2',
        { attr: { points: '1,203 1,150.3 97.2,215.7 97.2,270.3' } },
        { attr: { points: '1,203 1,68.3 97.2,135.7 97.2,270.3' }, duration: 3.6 },
        1.5)
      .fromTo('#polygon3',
        { attr: { points: '193.3,148 97.2,215 1,148.3 97.2,80' } },
        { attr: { points: '193.3,68.3 97.2,135.7 1,68.3 97.2,1' }, duration: 3.6 },
        1.5)
      .fromTo('.b2c-header-bg--blue-building', { opacity: 0.75 }, { duration: 2, opacity: 0, delay: 5.5 }, 6)

    const game = { score: 0 }

    function updateHandler () {
      if (document.getElementById('score-1')) {
        document.getElementById('score-1').innerHTML = `+${game.score}`
      }
    }

    const onComplete = () => {
      game.score = 0
      updateHandler()
    }

    if (screen.width > 1100) {
      new TimelineMax({ repeat: 5, delay: 1, repeatDelay: 2 })
        .fromTo('#b2c-chart--score-container', { opacity: 0 }, { opacity: 1, duration: 3 }, 0)
        .fromTo('#progress_animate1', { 'stroke-dasharray': '4, 300' }, { 'stroke-dasharray': '240', duration: 3.6, ease: Expo.easeNone }, 0.5)
        .fromTo(game, { score: '+0' }, { duration: 3.6, score: '+80', roundProps: 'score', onUpdate: updateHandler, ease: Expo.easeNone }, 0.5)
        .to('#b2c-chart--score-container', 2, { opacity: 0, onComplete, delay: 5 }, 5)
        .to('#progress_animate1', 2, { opacity: 0, onComplete, delay: 5 }, 5)
    }
  }, 300)
})
</script>

<template lang="pug">
.b2c-header--container
  b2-c-header-b-g
  b2-c-header-chart(v-if="screen.width > 1100")
  .b2c-header--content.routerPageSize
    .b2c-header--title
      | Hat Ihre
      br
      | Liegenschaft
      br
      | noch
      span.b2c-header--title-blue Potenzial?
    .b2c-search--container
      b2-c-search-box
  .b2c-info-line--container
    .routerPageSize
      .b2c-info-line--content
        .b2c-info-svg
          svg(width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M30 0H0V30H30V0Z' fill='#FF0000')
            path(d='M18 12H12V18H18V12Z' fill='white')
            path(d='M18 6H12V12H18V6Z' fill='white')
            path(d='M18 18H12V24H18V18Z' fill='white')
            path(d='M24 12H18V18H24V12Z' fill='white')
            path(d='M12 12H6V18H12V12Z' fill='white')
        .b2c-info-text Ein Schweizer Service für den Schweizer Immobilienmarkt.
</template>

<style lang="sass">
.b2c-header--container
  position: relative
  width: 100%
  z-index: 9
  display: flex
  overflow: hidden
  height: 100vh
  @media screen and (min-width: 1024px)
    align-items: center
    justify-content: center
  .b2c-header--content
    margin: unset !important
    position: relative
    @media screen and (min-width: 1024px)
      padding: 0 50px
    @media screen and (max-width: 1024px)
      background: linear-gradient(146.52deg, rgba(33, 37, 46, 0.85) 42.33%, rgba(33, 37, 46, 0) 64.9%)
      padding: 120px 20px 0
    .b2c-header--title
      font-weight: 500
      color: white
      max-width: 693px
      font-size: 55px
      @media screen and (min-width: 600px)
        line-height: 64px
        font-size: 55px
        margin-bottom: 38px
      @media screen and (max-width: 600px)
        font-size: 30px
        line-height: 35px
        margin-bottom: 30px
    .b2c-header--title-blue
      color: #007BFF !important
      @media screen and (min-width: 600px)
        margin-left: 15px
        line-height: 64px
        font-size: 55px
      @media screen and (max-width: 600px)
        margin-left: 8px
        font-size: 30px
        line-height: 35px
  .b2c-info-line--container
    position: absolute
    left: 0px
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    @media screen and (min-width: 600px)
      bottom: 60px
    @media screen and (max-width: 600px)
      bottom: 27px
    .b2c-info-line--content
      @media screen and (min-width: 600px)
        display: flex
        flex-direction: row
        align-items: center
        padding: 0 50px
      @media screen and (max-width: 600px)
        width: 214px
        padding-left: 15px
      .b2c-info-svg
        margin-right: 19px
      .b2c-info-text
        font-weight: 600
        font-size: 16px
        line-height: 154%
        color: rgba(255, 255, 255, 0.8)
</style>
